import { useContext } from 'react';

import { TagFormContext } from './tag-form-context';

export const useOpenCreateTagDialog = () => {
  const { onCreateTag } = useContext(TagFormContext);

  return onCreateTag;
};
